import React, { useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../../../../../stateManager/store";
import { Transition, Disclosure} from "@headlessui/react";
import { updateElement} from "../../../../../../stateManager/store/formCreation_v2/actions";
import {ReactComponent as Down} from "../../../../../../assets/svg/solobuilder/dropdown-down.svg";
import {ReactComponent as Up} from "../../../../../../assets/svg/solobuilder/dropdown-up.svg";
import {ReactComponent as Delete} from "../../../../../../assets/svg/solobuilder/expansion-delete.svg";

export const FilterExpansion = ((props: any) => {
    const {config, setColorPickerContext} = props;
    const {selectedElementId, components, deviceType, canvasConfig} = useSelector((state: AppState) => state.formJson);
    const component = components[ selectedElementId ] || {};
    const {type = ""} = component;
    const columnFilters = components[ selectedElementId ]?.properties?.config?.columnFilters
    const properties = component?.properties?.config
    const [ tabAddMode, setTabAddMode ] = useState<boolean>(false)
    const [ tabData, setTabData ] = useState<any>({})
    const [ filters, setFilters ] = useState<any>([])
    const dispatch = useDispatch();
    const [ filterFields, setFilterFields ] = useState<any>({
        columnID: "",
    })

    const handleChange = (path: any, value: any) => {
        dispatch(
            updateElement({
                id: selectedElementId,
                path,
                value,
            })
        );
    }

    const addFilter = () => {
        let filter = {
            id : Math.random().toString(36).substring(6),
            key: `filter_${columnFilters && columnFilters?.length + 1}`,
            Column_id: filterFields.columnID
        }

        setFilters((prev: any) => ([ ...prev, filter ]))
        setTabAddMode(false)
        setFilterFields({
            ...filterFields,
            columnID: "",
        })
    }

    useEffect(() => {
        if (filters) {
            handleChange("properties.config.columnFilters", filters)
        }
    }, [ filters ])

    useEffect(() => {
        if (columnFilters) {
            setFilters(columnFilters)
        }
    }, [])

    const removeFilter = (e: React.MouseEvent<HTMLElement>, removeItem: any) => {
        e.stopPropagation();
        let temp = filters.length > 1 ? filters.filter((val: any) => {
            return val.id !== removeItem.id
        }) : []
        setFilters(temp);
    }

    return (
        <div className="w-full">
            <div className="w-full bg-transparent">
                <div style={{
                    display: "flex", alignItems: "center",
                    justifyContent: "space-between",
                    margin: "10px 0px"
                }}>
                    <label style={{fontWeight: 700, fontSize: "11px", color: "#282B31", margin: "0px"}}>
                        Add filter
                    </label>
                    {!tabAddMode ?
                        <button onClick={(() => {setTabAddMode(true)})} type="button"
                        style={{
                            outline: "none", background: "#052f35 ",
                            borderRadius: "50px",display:"flex",alignItems:"center",justifyContent:"center",
                            color: "white", cursor: "pointer",width:"41px",height:"21px",fontSize:"10px",fontWeight:700
                        }}>ADD</button>
                        : <div>
                            <button onClick={(() => {setTabAddMode(false)})}
                                style={{
                                    outline: "none", background: "none",
                                    color: "#969BA5", padding: "4px 9px", cursor: "pointer"
                                }}>Cancel</button>
                            <button onClick={(() => {addFilter()})} type="button"
                                style={{
                                    outline: "none", background: "#052f35 ",borderRadius: "50px",color: "white", cursor: "pointer",
                                    width:"56px",height:"21px",fontSize:"10px",fontWeight:700
                                }}>SUBMIT</button>
                        </div>
                    }
                </div>
                {
                    <FilterExpansionPanel
                        removeFilter={(e: any, item: any) => removeFilter(e, item)}
                        filters={filters}
                        filterFields={filterFields}
                        setFilterFields={setFilterFields}
                        columnFilters={columnFilters}
                        tabAddMode={tabAddMode}
                        isCheckedIn={props.isCheckedIn}
                        handleChange={handleChange}
                    />
                }
            </div>
        </div>
    )
})



export const FilterExpansionPanel = (props: any) => {
    const {filterFields, setFilterFields, removeFilter} = props

    const filterIDChanges = (data: any) => {
        let onchangeFilter = props.columnFilters
        onchangeFilter[data.idx].Column_id = data.value
        props.handleChange(`properties.config.columnFilters`, onchangeFilter)
    }

    return (
        <div className="w-full">
            <div className="w-full bg-transparent">
                {
                    props.tabAddMode &&
                    <div style={{display: "flex", flexDirection: "column"}}>
                        <div style={{display: "flex", alignContent: "center", justifyContent: "space-between"}}>
                            <div style={{
                                width: "60px", display: "flex",
                                alignItems: "center", fontWeight: 600,
                                fontSize: "11px", color: "#282B31"
                            }} >{"Column id"}</div>
                            <input
                                value={filterFields && filterFields?.columnID}
                                className="panel-input outline-none" placeholder="eg: colid12"
                                onChange={(e: any) => setFilterFields({...filterFields, columnID: e.target.value})}
                            >
                            </input>
                        </div>
                    </div>
                }
                {
                    props.columnFilters && props.columnFilters?.length > 0 && props.columnFilters.map((items: any, i: number) => {
                        
                        return (
                            <div key={i} style={{marginTop:"10px"}} >
                                <Disclosure>
                                    {({open}) => (
                                        <>
                                            <Disclosure.Button style={{height: "28px", width:"100%", alignItems: "center", fontSize: "12px", fontWeight: 700, padding: "8px", borderRadius: "4px", background: "#EFF0F4", color: "#505F7B"}}
                                                className="flex w-full justify-between rounded-sm  text-left  text-purple-900 hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                                                <span>{`Filter ${i + 1}`}</span>
                                                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                                    <Delete height="15px"
                                                        onClick={(e: any) => removeFilter(e, items)}
                                                    />
                                                    <span>
                                                        {
                                                            open ? <Up></Up> : <Down></Down>
                                                        }
                                                    </span>
                                                </div>
                                            </Disclosure.Button>
                                            <Transition
                                                show={open}
                                                enter="transition duration-100 ease-out"
                                                enterFrom="transform scale-95 opacity-0"
                                                enterTo="transform scale-100 opacity-100"
                                                leave="transition duration-75 ease-out"
                                                leaveFrom="transform scale-100 opacity-100"
                                                leaveTo="transform scale-95 opacity-0"
                                            >
                                                <div style={{border: "1.5px solid #EFF0F4", borderTop: "none", marginTop: "-3px", padding: "10px 5px 0px 5px", borderTopLeftRadius: "0px", borderTopRightRadius: "0px", borderBottomRightRadius: "4px", borderBottomLeftRadius: "4px"}}>
                                                    <Disclosure.Panel static>
                                                        <div style={{display: "flex", flexDirection: "column", gap: "10px", paddingBottom: "8px"}}>
                                                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                                                <div style={{
                                                                    width: "60px", display: "flex",
                                                                    alignItems: "center", fontWeight: 600,
                                                                    fontSize: "11px", color: "#282B31"
                                                                }} >{"Column id"}</div>
                                                                <input
                                                                    className="panel-input outline-none" placeholder="eg: colid12, colid23,"
                                                                    onChange={(event: any) => filterIDChanges({currentVal: items.Column_id, value: event.target.value, idx: i})}
                                                                    value={items.Column_id}
                                                                ></input>
                                                            </div>
                                                        </div>
                                                    </Disclosure.Panel>
                                                </div>
                                            </Transition>
                                        </>
                                    )}
                                </Disclosure>
                            </div>
                        )


                    })
                }
            </div>
        </div>
    )
}

